module.exports = "/_next/static/images/circle-grey-2a8bb2fe7d94e6969bd5d4bc68346fe9.png";